// extracted by mini-css-extract-plugin
export default {"container":"styles_container__WMvaW","footnote":"styles_footnote__z6zBV","grayText":"styles_grayText__EJeqP"};